export interface Movie {
  id: string;
  title: string;
  year: number;
  category: string;
  categories: string[];
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    year: 2026,
    category: '电影',
    categories: ['电影', '科幻', '冒险'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20style%2C%20astronaut%20in%20space%20with%20glowing%20earth%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20dark%20atmosphere%20with%20orange%20and%20gold%20accents%2C%20clean%20minimal%20composition%2C%20professional%20poster%20design%2C%20no%20text&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀，即将吞没整个太阳系。人类面临前所未有的生存危机，各国联合起来在地球表面建造了上万座行星发动机，推动地球逃离太阳系，开启了长达2500年的星际流浪之旅。在这场关乎人类命运的宏大征程中，无数英雄挺身而出，用勇气和智慧书写着人类文明的壮丽篇章。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '150分钟',
    updateInfo: '2026年最新上映',
    isHot: true,
    isNew: true,
    tags: ['科幻巨制', '国产良心', '视觉盛宴'],
  },
  {
    id: 'movie-2',
    title: '满江红2',
    year: 2026,
    category: '电影',
    categories: ['电影', '历史', '悬疑'],
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20ancient%20Chinese%20soldiers%20in%20red%20armor%2C%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%20with%20warm%20tones%2C%20professional%20film%20poster%20design%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大阴谋之中，层层反转，步步惊心。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    region: '中国大陆',
    duration: '159分钟',
    updateInfo: '2026年春节档',
    isHot: true,
    isNew: false,
    tags: ['悬疑反转', '历史大戏', '春节档'],
  },
  {
    id: 'movie-3',
    title: '哪吒之魔童闹海',
    year: 2025,
    category: '电影',
    categories: ['电影', '动画', '奇幻'],
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20mythical%20warrior%20character%20with%20flaming%20weapons%2C%20dramatic%20dynamic%20pose%2C%20dark%20background%20with%20fire%20and%20gold%20elements%2C%20cinematic%20animation%20style%2C%20epic%20composition%2C%20no%20text&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。但是在重塑肉身的过程中却遇到重重困难，哪吒和敖丙的命运将走向何方？',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    region: '中国大陆',
    duration: '144分钟',
    updateInfo: '国产动画票房冠军',
    isHot: true,
    isNew: false,
    tags: ['国漫之光', '票房冠军', '全家欢'],
  },
  {
    id: 'movie-4',
    title: '长津湖之水门桥',
    year: 2022,
    category: '电影',
    categories: ['电影', '战争', '历史'],
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20drama%20movie%20poster%2C%20soldiers%20in%20winter%20battlefield%20snow%20scene%2C%20dramatic%20cinematic%20lighting%2C%20cold%20atmosphere%20with%20warm%20orange%20sparks%2C%20epic%20heroic%20composition%2C%20professional%20film%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了在结束了新兴里和下碣隅里的战斗之后，七连战士们又接到了更艰巨的任务——炸毁水门桥，阻断美军撤退的必经之路。',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '朱亚文'],
    region: '中国大陆',
    duration: '149分钟',
    updateInfo: '经典战争巨制',
    isHot: false,
    isNew: false,
    tags: ['战争史诗', '爱国情怀', '震撼人心'],
  },
  {
    id: 'movie-5',
    title: '庆余年2',
    year: 2024,
    category: '电视剧',
    categories: ['电视剧', '古装', '权谋'],
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20elegant%20man%20in%20traditional%20Chinese%20robe%2C%20dramatic%20cinematic%20lighting%2C%20dark%20atmosphere%20with%20gold%20and%20warm%20tones%2C%20mysterious%20palace%20setting%2C%20professional%20TV%20drama%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。范闲所面对的抱月楼迷局，以及接踵而至的春闱危机，都是二皇子精心给范闲布下的陷阱。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    region: '中国大陆',
    duration: '45分钟/集 共36集',
    updateInfo: '全36集已完结',
    isHot: true,
    isNew: false,
    tags: ['权谋大戏', '演技炸裂', '年度剧王'],
  },
  {
    id: 'movie-6',
    title: '三体',
    year: 2023,
    category: '电视剧',
    categories: ['电视剧', '科幻', '悬疑'],
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20mysterious%20three%20body%20problem%20concept%2C%20cosmic%20science%20fiction%20theme%2C%20dark%20space%20background%20with%20glowing%20elements%2C%20cinematic%20atmosphere%20with%20cool%20and%20warm%20contrast%2C%20professional%20drama%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界，神秘莫测的《三体》游戏……纳米科学家汪淼被警官史强带到联合作战中心，并潜入"科学边界"组织协助调查。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    region: '中国大陆',
    duration: '45分钟/集 共30集',
    updateInfo: '全30集已完结',
    isHot: false,
    isNew: false,
    tags: ['硬核科幻', '神作改编', '国产突破'],
  },
  {
    id: 'movie-7',
    title: '繁花',
    year: 2024,
    category: '电视剧',
    categories: ['电视剧', '剧情', '年代'],
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20Shanghai%20nostalgic%20aesthetic%2C%20elegant%20couple%20in%20vintage%201990s%20style%20clothing%2C%20warm%20golden%20lighting%2C%20dark%20cinematic%20atmosphere%2C%20professional%20TV%20drama%20poster%20design%2C%20no%20text&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼跻身成为商界后起之秀，黄河路上无人不晓。平凡阿宝蜕变为宝总，离不开高人爷叔与夜东京老板玲子、外贸大楼汪小姐的鼎力相助。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    region: '中国大陆',
    duration: '45分钟/集 共30集',
    updateInfo: '全30集已完结',
    isHot: true,
    isNew: false,
    tags: ['王家卫美学', '年度神剧', '上海故事'],
  },
  {
    id: 'movie-8',
    title: '长安三万里',
    year: 2023,
    category: '动漫',
    categories: ['动漫', '动画', '历史'],
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%2C%20ancient%20Tang%20dynasty%20poet%20on%20horseback%2C%20beautiful%20traditional%20Chinese%20painting%20style%2C%20warm%20golden%20and%20earthy%20tones%2C%20cinematic%20animation%20aesthetic%2C%20majestic%20composition%2C%20no%20text&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。两位伟大诗人跌宕起伏的命运就此展开。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    duration: '168分钟',
    updateInfo: '追光动画巅峰之作',
    isHot: false,
    isNew: false,
    tags: ['盛唐风华', '诗歌之美', '国风动画'],
  },
  {
    id: 'movie-9',
    title: '斗罗大陆2',
    year: 2025,
    category: '动漫',
    categories: ['动漫', '热血', '奇幻'],
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20animation%20poster%2C%20young%20warrior%20with%20martial%20arts%20pose%2C%20magical%20energy%20surrounding%2C%20dark%20background%20with%20golden%20and%20blue%20light%20effects%2C%20dynamic%20action%20composition%2C%20anime%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    description: '唐三历经重重磨难，终于踏上了成为强者的道路。在史莱克学院中，他与伙伴们一同修炼，共同面对更强大的对手。武魂殿的阴谋逐渐浮出水面，一场席卷大陆的风暴即将来临。',
    director: '沈乐平',
    actors: ['沈磊', '程玉珠', '黄莺'],
    region: '中国大陆',
    duration: '20分钟/集 更新中',
    updateInfo: '每周六更新',
    isHot: true,
    isNew: true,
    tags: ['热血战斗', '国漫标杆', '年番巨制'],
  },
  {
    id: 'movie-10',
    title: '奔跑吧·生态篇',
    year: 2025,
    category: '综艺',
    categories: ['综艺', '户外', '真人秀'],
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20outdoor%20nature%20scene%2C%20bright%20vibrant%20colors%2C%20playful%20energetic%20atmosphere%2C%20dark%20green%20background%20with%20warm%20sunlight%2C%20professional%20TV%20show%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    description: '本季节目以"生态保护"为主题，跑男团将走进祖国的大好河山，在绿水青山间展开一场场趣味盎然又充满意义的挑战。通过游戏互动传递环保理念，展现美丽中国的生态画卷。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '沙溢', '白鹿', '周深'],
    region: '中国大陆',
    duration: '90分钟/期',
    updateInfo: '每周五更新',
    isHot: false,
    isNew: true,
    tags: ['户外竞技', '全明星', '轻松解压'],
  },
  {
    id: 'movie-11',
    title: '王牌对王牌8',
    year: 2024,
    category: '综艺',
    categories: ['综艺', '室内', '游戏'],
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20poster%2C%20celebrities%20on%20colorful%20stage%20with%20spotlights%2C%20fun%20game%20show%20atmosphere%2C%20dark%20background%20with%20vibrant%20stage%20lighting%2C%20warm%20and%20energetic%20composition%2C%20professional%20show%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    description: '沈腾、贾玲、华晨宇、关晓彤以及沈涛组成的王牌家族继续在第八季中为大家带来欢笑。经典IP剧组重聚、爆笑游戏对决、温情催泪瞬间，王牌对王牌，欢笑不停歇。',
    director: '吴彤',
    actors: ['沈腾', '华晨宇', '关晓彤', '宋亚轩'],
    region: '中国大陆',
    duration: '90分钟/期',
    updateInfo: '全12期已完结',
    isHot: false,
    isNew: false,
    tags: ['喜剧综艺', 'IP重聚', '笑声不断'],
  },
  {
    id: 'movie-12',
    title: '河西走廊',
    year: 2015,
    category: '纪录片',
    categories: ['纪录片', '历史', '人文'],
    rating: 9.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20poster%2C%20ancient%20Silk%20Road%20Hexi%20Corridor%20landscape%2C%20vast%20desert%20and%20mountain%20scenery%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20documentary%20aesthetic%2C%20majestic%20historical%20atmosphere%2C%20no%20text&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    description: '该片以位于中国西部的重要通道——河西走廊为讲述对象，从政治、军事、经济、文化、宗教等多角度呈现了从汉代开始直至今天，河西走廊及其连接的中国西部的历史。',
    director: '赵启辰',
    actors: ['吕树廷', '让波', '艾力江·库尔班'],
    region: '中国大陆',
    duration: '50分钟/集 共10集',
    updateInfo: '豆瓣9.7分神作',
    isHot: false,
    isNew: false,
    tags: ['历史人文', '豆瓣高分', '必看神作'],
  },
  {
    id: 'movie-13',
    title: '舌尖上的中国4',
    year: 2025,
    category: '纪录片',
    categories: ['纪录片', '美食', '人文'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20delicious%20traditional%20Chinese%20cuisine%20closeup%2C%20steaming%20hot%20dishes%20with%20beautiful%20presentation%2C%20warm%20golden%20lighting%2C%20dark%20background%2C%20mouth-watering%20food%20photography%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-13&orientation=portrait',
    description: '第四季延续舌尖系列对中华美食文化的深度探索，聚焦当代中国人的饮食变迁。从街头小吃到国宴大餐，从传统手艺到创新融合，用镜头记录下食物背后的人情味和文化传承。',
    director: '陈晓卿',
    actors: ['李立宏'],
    region: '中国大陆',
    duration: '50分钟/集 共8集',
    updateInfo: '全8集已完结',
    isHot: false,
    isNew: true,
    tags: ['美食文化', '人间烟火', '温情治愈'],
  },
  {
    id: 'movie-14',
    title: '独行月球',
    year: 2022,
    category: '电影',
    categories: ['电影', '喜剧', '科幻'],
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%2C%20astronaut%20standing%20alone%20on%20moon%20surface%2C%20humorous%20and%20lonely%20atmosphere%2C%20dark%20space%20background%20with%20earth%20in%20distance%2C%20warm%20lighting%20on%20character%2C%20cinematic%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-14&orientation=portrait',
    description: '人类为抵御小行星的撞击，拯救地球，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了领队的撤离通知，一个人落在了月球。不料月盾计划失败，独孤月成为了"宇宙最后的人类"。',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '常远'],
    region: '中国大陆',
    duration: '122分钟',
    updateInfo: '开心麻花科幻喜剧',
    isHot: false,
    isNew: false,
    tags: ['科幻喜剧', '沈腾马丽', '笑中带泪'],
  },
  {
    id: 'movie-15',
    title: '狂飙',
    year: 2023,
    category: '电视剧',
    categories: ['电视剧', '犯罪', '剧情'],
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20two%20men%20facing%20each%20other%20in%20tense%20standoff%2C%20dark%20noir%20atmosphere%2C%20police%20and%20criminal%20underworld%20theme%2C%20dramatic%20contrast%20lighting%2C%20professional%20TV%20series%20poster%2C%20no%20text&width=600&height=800&seq=movie-poster-15&orientation=portrait',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，一举铲除了盘踞京海多年的强盛集团。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
    duration: '45分钟/集 共39集',
    updateInfo: '全39集已完结',
    isHot: true,
    isNew: false,
    tags: ['现象级爆款', '演技封神', '年度剧王'],
  },
  {
    id: 'movie-16',
    title: '深海',
    year: 2023,
    category: '动漫',
    categories: ['动漫', '动画', '奇幻'],
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20girl%20in%20underwater%20dreamlike%20world%2C%20vibrant%20colorful%20deep%20sea%20creatures%2C%20dark%20ocean%20background%20with%20bioluminescent%20elements%2C%20beautiful%20surreal%20animation%20style%2C%20no%20text&width=600&height=800&seq=movie-poster-16&orientation=portrait',
    description: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。绚丽到极致的色彩之下，是一个关于孤独与救赎的温暖故事。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文', '滕奎兴'],
    region: '中国大陆',
    duration: '112分钟',
    updateInfo: '粒子水墨视觉革命',
    isHot: false,
    isNew: false,
    tags: ['视觉革命', '治愈系', '粒子水墨'],
  },
];

export const heroSlides = [
  {
    id: 'hero-1',
    movieId: 'movie-1',
    title: '流浪地球3',
    subtitle: '太阳危机升级，人类命运何去何从',
    description: '2026年最受期待的科幻史诗巨制，吴京、刘德华倾情主演',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%2C%20giant%20planetary%20engines%20on%20earth%20surface%20facing%20the%20sun%2C%20dramatic%20orange%20and%20dark%20atmosphere%2C%20massive%20scale%2C%20cinematic%20movie%20quality%2C%20warm%20fiery%20tones%2C%20epic%20composition%2C%20no%20text%20or%20lettering&width=1920&height=800&seq=hero-bg-01&orientation=landscape',
    rating: 8.9,
    tag: '热播推荐',
  },
  {
    id: 'hero-2',
    movieId: 'movie-5',
    title: '庆余年2',
    subtitle: '范闲归来，京都风云再起',
    description: '权谋升级、阵容炸裂，张若昀领衔年度最热古装大剧',
    bgImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20cinematic%20scene%2C%20majestic%20imperial%20court%20with%20warm%20golden%20lighting%2C%20dramatic%20atmosphere%2C%20historical%20costume%20drama%20aesthetic%2C%20dark%20corners%20with%20lantern%20glow%2C%20cinematic%20quality%2C%20no%20text&width=1920&height=800&seq=hero-bg-02&orientation=landscape',
    rating: 9.1,
    tag: '年度剧王',
  },
  {
    id: 'hero-3',
    movieId: 'movie-3',
    title: '哪吒之魔童闹海',
    subtitle: '我命由我不由天',
    description: '国产动画票房冠军，视觉与情感的双重盛宴',
    bgImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20cinematic%20scene%2C%20epic%20battle%20with%20fire%20and%20lightning%20effects%2C%20dramatic%20dynamic%20composition%2C%20dark%20atmosphere%20with%20fiery%20warm%20accents%2C%20animated%20movie%20cinematic%20quality%2C%20powerful%20energy%2C%20no%20text&width=1920&height=800&seq=hero-bg-03&orientation=landscape',
    rating: 9.2,
    tag: '国漫之光',
  },
];

export const hotList = movies.filter(m => m.isHot).slice(0, 8);
export const newList = movies.filter(m => m.isNew).slice(0, 8);
export const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);